import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/components/components.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { ResumeSamplePageRoutingModule } from './resume-sample-routing.module';
import { ResumeSamplePage } from './resume-sample.page';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    IonicModule,
    ResumeSamplePageRoutingModule,
    TranslateModule,
    SharedModule,
  ],
  declarations: [ResumeSamplePage],
})
export class ResumeSamplePageModule {}
